import { type BasicProps } from '@eastcoal/common/types/component'
import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { MemberStatusLink } from '@eastcoal/shared/components/MemberStatusLink'
import { MemberType } from '@eastcoal/shared/enums/MemberType'

import { SwitchMemberButton } from './SwitchButton'

export const EnterpriseInfo = (props: BasicProps) => {
  const {
    member: { memberStatus, name, type }
  } = useAuthStore(state => pick(state, ['member', 'members']))

  if (type !== MemberType.ENTERPRISE) {
    return null
  }

  return (
    <div {...props}>
      <MemberStatusLink memberStatus={memberStatus} />
      <span>{name}</span>
      <SwitchMemberButton />
    </div>
  )
}
